import { AIBot } from "./AIBot";

export class DocuBot extends AIBot {
  public files: DocuBotFile[] = [];
  public isIndexCreated = false;
  public isProcessing = false;
  public hideFiles?: boolean;

  constructor(public roomId: string) {
    super('ai-docubot');
  }
}

export class DocuBotFile {
  public isTrained = false;

  constructor(public filename: string, public url: string, public sizeByte: number, public type: string) {

  }
}
